<div
  class="wum-backdrop"
  *ngIf="isOpen"
  (click)="onBackdropClick($event)"
  role="dialog"
  aria-modal="true"
  aria-labelledby="weekly-updates-title">
  <div class="wum-particles" aria-hidden="true">
    <span class="wum-particle" *ngFor="let p of [1,2,3,4,5,6,7,8]"></span>
  </div>
  <div class="wum-glow wum-glow--left" aria-hidden="true"></div>
  <div class="wum-glow wum-glow--right" aria-hidden="true"></div>

  <div class="wum-modal" (click)="$event.stopPropagation()">
    <header class="wum-header">
      <div class="wum-header-text">
        <span class="wum-badge">{{ weekLabel }}</span>
        <h2 id="weekly-updates-title" class="wum-title">🚀 Weekly Product Updates</h2>
        <p class="wum-subtitle">Here's everything that changed in Cargo Heating during the last week.</p>
      </div>
      <button type="button" class="wum-close" (click)="close()" aria-label="Close">
        <mat-icon>close</mat-icon>
      </button>
    </header>

    <div class="wum-body">
      <section class="wum-section">
        <div class="wum-section-head">
          <h3>Release Summary</h3>
          <p>At-a-glance overview of this week's shipment</p>
        </div>
        <div class="wum-cards-grid">
          <article
            class="wum-summary-card"
            *ngFor="let card of summaryCards"
            [attr.data-accent]="card.accent">
            <div class="wum-card-top">
              <span class="wum-card-emoji" aria-hidden="true">{{ card.emoji }}</span>
              <span class="wum-card-icon-wrap">
                <mat-icon>{{ card.icon }}</mat-icon>
              </span>
            </div>
            <div class="wum-card-count">{{ card.count }}</div>
            <h4 class="wum-card-title">{{ card.title }}</h4>
            <p class="wum-card-desc">{{ card.description }}</p>
          </article>
        </div>
      </section>

      <section class="wum-section wum-section--split">
        <div class="wum-timeline-col">
          <div class="wum-section-head">
            <h3>Weekly Highlights</h3>
            <p>Key changes shipped this week</p>
          </div>
          <ol class="wum-timeline">
            <li class="wum-timeline-item" *ngFor="let item of timelineItems">
              <div class="wum-timeline-marker">
                <mat-icon>{{ item.icon }}</mat-icon>
              </div>
              <div class="wum-timeline-content">
                <div class="wum-timeline-meta">
                  <time>{{ item.date }}</time>
                  <span class="wum-tag">{{ item.tag }}</span>
                </div>
                <h4>{{ item.title }}</h4>
                <p>{{ item.description }}</p>
              </div>
            </li>
          </ol>
        </div>

        <div class="wum-screenshots-col">
          <div class="wum-section-head">
            <h3>📸 What's New in UI</h3>
            <p>Preview the latest interface improvements</p>
          </div>
          <div class="wum-screenshots-grid">
            <article class="wum-screenshot-card" *ngFor="let shot of screenshotCards">
              <div class="wum-screenshot-thumb" [style.background]="shot.gradient">
                <div class="wum-screenshot-mock">
                  <span class="wum-mock-bar"></span>
                  <span class="wum-mock-bar wum-mock-bar--short"></span>
                  <span class="wum-mock-block"></span>
                  <span class="wum-mock-block wum-mock-block--sm"></span>
                </div>
                <mat-icon class="wum-screenshot-icon">{{ shot.icon }}</mat-icon>
              </div>
              <div class="wum-screenshot-body">
                <h4>{{ shot.title }}</h4>
                <p>{{ shot.description }}</p>
              </div>
            </article>
          </div>
        </div>
      </section>
    </div>

    <footer class="wum-footer">
      <p class="wum-footer-note">
        More updates coming soon — this release notes experience will appear automatically on login.
      </p>
      <div class="wum-footer-actions">
        <button type="button" class="wum-btn wum-btn--ghost" (click)="close()">
          <mat-icon>explore</mat-icon>
          Explore Updates
        </button>
        <button type="button" class="wum-btn wum-btn--primary" (click)="close()">
          <mat-icon>check_circle</mat-icon>
          Got It
        </button>
      </div>
    </footer>
  </div>
</div>
